module.exports = __webpack_public_path__ + "assets/1ad9ea5d04f9c20ea982fdee6ccb3568.svg";